import React, { ReactElement } from 'react';
import Link from 'next/link';

import { Article } from '@constants/types';
import Grid from '@components/grid';
import Button from '@components/ui/button';
import ResourceItem from '@components/resource-item';
import ResourceItemLoader from '@components/ui/loaders/resource-feed-loader';

interface Props {
  isLoading?: boolean;
  isError?: boolean;
  error?: any;
  data: any;
}

export default function ResourceGridSection({
  isLoading = false,
  isError = false,
  error,
  data,
}: Props): ReactElement {
  if (isError) console.log(error);
  return (
    <Grid>
      {isLoading && <ResourceItemLoader />}

      {!isLoading &&
        data &&
        data?.length > 0 &&
        data.map((resource: Article) => {
          return (
            <ResourceItem
              key={`resource--key${resource.id}`}
              resource={resource}
            />
          );
        })}

      {!isLoading && data?.length === 0 && (
        <div className="col-span-full w-full p-6 md:p-8 lg:p-10 bg-accent-1 flex justify-center items-center">
          <div className="flex flex-col justify-center items-start">
            <h4>
              No resources found matching this filter. Please select another and
              try again. Go back?
            </h4>

            <Link passHref href={`/blog`}>
              <Button variant="cta" className="mt-8">
                Go back
              </Button>
            </Link>
          </div>
        </div>
      )}

      {!isLoading && isError && (
        <div className="col-span-full w-full py-10 bg-accent-1 flex justify-center items-center">
          <div className="flex flex-col justify-center items-start">
            <h4>500: Issue collecting articles for this category.</h4>

            <Link passHref href={`/blog`}>
              <Button variant="cta" className="mt-8">
                Go back
              </Button>
            </Link>
          </div>
        </div>
      )}
    </Grid>
  );
}
